import React from 'react';
import Chatbot from '../../types/Chatbot';
import Organisation from '../../types/Organisation';

interface ChatbotContextProps {
  chatbots: Chatbot[];
  currentChatbot: Chatbot | null;
  setCurrentChatbot: (chatbotId: number | null) => Promise<void>;
  refreshChatbots: () => Promise<void>;
  selectedOrganisation: Organisation | null;
  setSelectedOrganisation: React.Dispatch<
    React.SetStateAction<Organisation | null>
  >;
  initialized: boolean;
  chatbotsRefreshKey: number;
}

const ChatbotContext = React.createContext<ChatbotContextProps>({
  chatbots: [],
  currentChatbot: null,
  setCurrentChatbot: async () => {},
  refreshChatbots: async () => {},
  selectedOrganisation: null,
  setSelectedOrganisation: () => {},
  initialized: false,
  chatbotsRefreshKey: 0
});

export default ChatbotContext;
